import { createContentPropTypes } from '../../helpers/content';

const chapsFileUploadDeadlineMissed = {
	strong: 'Payment deadline missed? ',
	description:
		'- missed payments will be submitted on the next available business day. Please review and confirm this change when providing final authorisation on the mobile banking app.',
};

export default { chapsFileUploadDeadlineMissed };

export const contentPropTypes = createContentPropTypes(chapsFileUploadDeadlineMissed);
